export const renderTestimonials = item => (
    <div className="testimonial">
        <div className="heading">
            <h3 className="body-1b">{item.author}</h3>
            <div className="stars">
                {[...Array(5)].map((_, index) => (
                    <svg
                        key={index}
                        width="19"
                        height="18"
                        viewBox="0 0 19 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M9.49983 14.5198L13.6498 17.0298C14.4098 17.4898 15.3398 16.8098 15.1398 15.9498L14.0398 11.2298L17.7098 8.04977C18.3798 7.46977 18.0198 6.36977 17.1398 6.29977L12.3098 5.88977L10.4198 1.42977C10.0798 0.619766 8.91983 0.619766 8.57983 1.42977L6.68983 5.87977L1.85983 6.28977C0.979828 6.35977 0.619828 7.45977 1.28983 8.03977L4.95983 11.2198L3.85983 15.9398C3.65983 16.7998 4.58983 17.4798 5.34983 17.0198L9.49983 14.5198Z"
                            fill="#132551"
                        />
                    </svg>
                ))}
            </div>
        </div>
        <p className={'body-2'}>{item.content}</p>
    </div>
);
